<template>
  <section class="section">
    <div class="container is-max-widescreen is-max-desktop">
      <h1 class="title has-text-centered">
        Réconciliation FDT / Frais
      </h1>
      <hr>
      <a href="https://dashboard.cen-nouvelle-aquitaine.org/public/dashboards/hM38v70Sr5lExbiQxOheK817gmHRWSsP2SMdW4a9?org_slug=default&p_annee=2024&p_mois=1" class="btn btn-link"
 role="button">Concordance entre la saisie des dépenses et des temps passés</a>
    </div>
  </section>
</template>

<script>

export default {
  name: "ReconciliationFdtFrais",
  components: {},
  mounted() {
    // this.$axios.get('Reconciliationfdtfrais')
  },
  computed: {},
  methods: {

  },
  data() {
    return {
      mois: '',
      annee: '',
      table: []
    }
  }
}

</script>

<style scoped>

.container {
  max-width: 100%;
  padding-left: 5%;
  padding-right: 5%;
}

</style>
